import React from 'react';
import block from 'bem-cn-lite';
import { PropTypes } from 'prop-types';

import I18N from '../../common/i18n';
import { Button } from '../../common/components';
import { Sections } from '../../common/enums';
import { getSectionLinkBody } from '../../../base/utils';
import { ITEMS_PER_PAGE } from '..';
import SectionListComplete from '../common/SectionListComplete';
import DropDownContainer from '../../common/components/DropDownContainer';
import icons from '../../common/icons';

const b = block('ListSection');

export default
class GroupList extends React.PureComponent {
  static title = I18N.GROUPS_LIST_TITLE

  static propTypes = {
    manifestId: PropTypes.number,
    orgId: PropTypes.number,
    itemElement: PropTypes.func,
    crud: PropTypes.object,
  };

  render() {
    return (
      <div className={b()}>
        <div className={b('Controls')}>
          <Button
            to={`${getSectionLinkBody(this.props.manifestId)}${Sections.GROUPS}/new`}
            className={b('Button')}
          >
            {I18N.GROUPS_ADD_BUTTON}
          </Button>
          <DropDownContainer>
            <Button
              icon={icons.COMMON_DELETE}
              to={`${getSectionLinkBody(this.props.manifestId)}${Sections.GROUPS}/delete`}
            >{I18N.MISC_DELETE_MULTIPLE}</Button>
          </DropDownContainer>
        </div>
        <SectionListComplete
          manifestId={this.props.manifestId || -this.props.orgId}
          queries={this.props.crud}
          variables={{
            'limit': ITEMS_PER_PAGE,
            'offset': 0,
            'manifest_id': this.props.manifestId || -this.props.orgId,
          }}
          itemElement={this.props.itemElement}
        />
      </div>
    );
  }
}
